import type { i18n as i18nInstance } from "i18next";

import { enUS, frFR } from "./i18n";
import { useLayoutEffect } from "react";
import { ProductTranslationProvider } from "@jasper/translations";

interface Props {
  children: React.ReactNode;
  i18n: i18nInstance;
}

export const ProductWorkflowsProvider = ({ children, i18n }: Props) => {
  useLayoutEffect(() => {
    if (!i18n.hasResourceBundle("en-US", "product-workflows")) {
      i18n.addResourceBundle("en-US", "product-workflows", enUS);
    }
    if (!i18n.hasResourceBundle("fr-FR", "product-workflows")) {
      i18n.addResourceBundle("fr-FR", "product-workflows", frFR);
    }
  }, [i18n]);

  return (
    <ProductTranslationProvider i18n={i18n}>
      {children}
    </ProductTranslationProvider>
  );
};
